import {
  GETNOTIFICATIONCONFIGADMIN_SUCCESS,
  GETNOTIFICATIONCONFIGADMIN_FAILED,
  RESET_GETNOTIFICATIONCONFIGADMIN,
  LOADING_GETNOTIFICATIONCONFIGADMIN,
  NETWORK_ERROR_GETNOTIFICATIONCONFIGADMIN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETNOTIFICATIONCONFIGADMIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETNOTIFICATIONCONFIGADMIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETNOTIFICATIONCONFIGADMIN_SUCCESS:
      console.log("cheking in red", action.payload);
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETNOTIFICATIONCONFIGADMIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETNOTIFICATIONCONFIGADMIN:
      return (state = initialState);
    default:
      return state;
  }
};
